/**
 * Liquid Glass 스타일 상수
 * Figma 디자인 기반 업데이트 (3152:2802)
 */

export const liquidGlassStyles = {
  // AI 메시지 버블 (Figma: 아바타 버블 스타일)
  aiBubble: {
    background: "rgba(255, 255, 255, 0.5)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    border: "1.5px solid rgba(255, 255, 255, 0.2)",
  },
  // 유저 메시지 버블
  userBubble: {
    background: "rgba(255, 255, 255, 0.35)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    border: "1.5px solid rgba(255, 255, 255, 0.15)",
  },
  // 입력 바
  inputBar: {
    background: "rgba(255, 255, 255, 0.15)",
  },
} as const;

export const ERROR_COLOR = "#EC5D5E";
